module.exports = __webpack_public_path__ + "static/media/user_input_2.d676ce1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WxGraphTool/user_input_2.png
// module id = 1773
// module chunks = 0